<template>
  <div class="paper-container">
    <!-- 试卷内容区域 -->
    <div id="paper-content"
         class="paper-content">
      <!-- 试卷标题 -->
      <header class="paper-header">
        <div>{{ paperTitle }}</div>
      </header>

      <div class="topic">
        <div class="topicItem"
             v-for="(item,index) in tabList"
             :key="index">
          <!-- 判断英语试卷材料题题目显示 -->
          <div class="topicTitle"
               v-if="item.answer_type_text != '材料题'"><span>{{item.number}}、</span> <span>{{item.answer_type_text}}</span>
          </div>
          <div class="topicTitle"
               v-if="item.answer_type_text == '材料题'&& !isAllEnglish(item.children[0].children[0].options[0].description)"><span>{{item.number}}、</span> <span>{{item.answer_type_text}}</span>
            <span></span>
          </div>
          <div v-for="(items,indexs) in item.children"
               :key="indexs">
            <div v-if="item.answer_type_text == '判断题'">
              <div class="descript">
                <span v-html="items.dts"
                      class="descritAnswer"></span>
              </div>
              <div class="option"
                   style="width:400px;">
                <div><span class="xuhao">A、</span>正确</div>
                <div><span class="xuhao">B、</span>错误</div>
              </div>
            </div>
            <div v-if="item.answer_type_text == '单选题'">
              <div class="descript">
                <span v-html="items.dts"
                      class="descritAnswer"></span>
              </div>
              <div class="option">
                <div :style="{'width':getWidth(items.options)}"><span class="xuhao">A、</span> <span v-html='items.options[0].description'></span></div>
                <div :style="{'width':getWidth(items.options)}"><span class="xuhao">B、</span><span v-html='items.options[1].description'></span></div>
                <div :style="{'width':getWidth(items.options)}"><span class="xuhao">C、</span><span v-html='items.options[2].description'></span></div>
                <div :style="{'width':getWidth(items.options)}"> <span class="xuhao"> D、</span><span v-html='items.options[3].description'></span></div>
              </div>
            </div>
            <div v-if="item.answer_type_text == '多选题'">
              <div class="descript"
                   style="marginTop:10px">
                <span v-html="items.dts"
                      class="descritAnswer"></span>
              </div>
              <!-- style="display:flex;padding-bottom:12px" -->
              <div class="multeoption">
                <div v-for='(optionItem,index) in items.options'
                     :key="index"
                     class="multeDiv"
                     :style="{'width':getWidth(items.options)}">
                  <span class="xuhao">{{optionItem.number}}</span>、 <span v-html='optionItem.description'></span>

                </div>
              </div>
            </div>
            <div v-if="item.answer_type_text == '填空题'">
              <div class="descript">
                <span v-html="items.dts"
                      class="descritAnswer"></span>
              </div>
            </div>
            <div v-if="item.answer_type_text == '问答题'">
              <div class="descript"
                   style="marginTop:13px">
                <span v-html="items.dts"
                      class="descritAnswer"
                      style="marginBottom:180px"></span>
              </div>
            </div>
            <div v-if="item.answer_type_text == '名词解释'">
              <div class="descript">
                <span v-html="items.dts"
                      class="descritAnswer"></span>
              </div>
            </div>
            <div v-if="item.answer_type_text == '简答题'">
              <div class="descript">
                <span v-html="items.dts"
                      class="descritAnswer"></span>
              </div>
            </div>
            <div v-if="item.answer_type_text == '论述题'">
              <div class="descript"
                   style="marginTop:13px">
                <span v-html="items.dts"
                      class="descritAnswer"
                      style="marginBottom:180px"></span>
              </div>
            </div>
            <div v-if="item.answer_type_text == '材料题'">
              <!-- 非英语试卷 -->
              <div class="descript"
                   v-if="!isAllEnglish(items.rich_text)">
                <span v-html="items.rich_text"
                      class="descritAnswer"></span>
              </div>
              <div class="descript"
                   v-else>
                <span v-html="items.rich_text"
                      class="descritAnswer"></span>
              </div>
              <div style="marginTop:30px"></div>
              <div v-for="(optionChild,indexChild) in items.children"
                   :key="indexChild"
                   class="dstContent">
                <div v-if="optionChild.answer_type_text == '单选题'">
                  <!-- 不是英语试题 -->
                  <div v-if="!isAllEnglish(optionChild.options[0].description)">
                    <div class="descriptChild">
                      <span v-html="optionChild.dts"></span>
                    </div>
                    <div class="option">
                      <div style="display:flex;"><span class="xuhao">A、</span> <span v-html='optionChild.options[0].description'></span></div>
                      <div style="display:flex"> <span class="xuhao">B、</span><span v-html='optionChild.options[1].description'></span></div>
                      <div style="display:flex"> <span class="xuhao">C、</span><span v-html='optionChild.options[2].description'></span></div>
                      <div style="display:flex"> <span class="xuhao">D、</span><span v-html='optionChild.options[3].description'></span></div>
                    </div>
                  </div>
                  <!-- 如果是英语试题 -->
                  <div v-if="isAllEnglish(optionChild.options[0].description)">
                    <!-- 完型填空 -->
                    <div class="english"
                         v-if="optionChild.description.includes('第')">
                      <div style="marginTop:-15px;width:25px;"> {{indexChild + 1}}、</div>
                      <div v-for="(item,index) in optionChild.options"
                           :key="index"
                           class="english">
                        <div class="option">
                          <div :style="{'width':getEnglish(item.description)}"><span> [{{multipleChoice[index]}}]</span><span v-html='item.description'></span></div>
                        </div>
                      </div>
                    </div>
                    <!-- 阅读理解-->
                    <div v-else>
                      <div style="marginTop:30px;color: rgba(0,0,0,0.9); font-family: 'MySongFont', serif;marginBottom:25px"
                           v-html="optionChild.dts"></div>
                      <div v-for="(item,index) in optionChild.options"
                           :key="index">

                        <!-- style="display:flex;width:100%;marginLeft:20px" -->
                        <div class="option"
                             style="marginLeft:28px;marginBottom:-5px">
                          <div :style="{'width':getEnglishuUnder(item.description)}"><span>[{{multipleChoice[index]}}]</span> <span v-html='item.description'></span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="optionChild.answer_type_text == '多选题'">
                  <div v-if="!isAllEnglish(optionChild.options[0].description)">
                    <div class="descriptChild">
                      <span>{{optionChild.num}}、</span> <span v-html="optionChild.dt"></span>
                    </div>
                    <div class="option">
                      <div style="display:flex;padding-bottom:12px; "
                           v-for='(childItem,index) in optionChild.options'
                           :key="index"><span class="xuhao">{{childItem.number}}</span> 、<span v-html='optionChild.options[index].description'>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="isAllEnglish(optionChild.options[0].description)">
                    <div class="descriptChild">
                      <span>{{optionChild.num}}、</span> <span v-html="optionChild.dt"></span>
                    </div>
                    <div>
                      <div style="display:flex;padding-bottom:12px;width:650px;line-height:20px"
                           v-for='(childItem,index) in optionChild.options'
                           :key="index"><span class="xuhao">{{childItem.number}}</span> 、<span v-html='optionChild.options[index].description'>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="optionChild.answer_type_text == '填空题'">
                  <div class="descriptChild">
                    <span v-html="optionChild.dts"></span>
                  </div>
                </div>
                <div v-if="optionChild.answer_type_text == '问答题'">
                  <div class="descriptChild">
                    <span v-html="optionChild.dts"
                          class="descritAnswer"
                          style="marginBottom:180px"></span>
                  </div>
                </div>
                <!-- <div v-if="optionChild.answer_type_text == '名词解释'">
                <div class="descriptChild">
                  <span v-html="optionChild.dts"></span>
                </div>
              </div> -->
              </div>
              <div style="marginBottom:30px"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 填空题部分 -->
      <!-- <section class="section-fill">
        <h2>二、填空题（每题5分，共30分）</h2>
        <div v-for="(question, index) in fillQuestions"
             :key="'fill-'+index"
             class="question-item">
          <p>{{ index + 1 }}. {{ question.replace(/_+/g, '________') }}</p>
        </div>
      </section> -->

      <!-- 解答题部分 -->
      <!-- <section class="section-answer">
        <h2>三、解答题（共20分）</h2>
        <div class="question-item">
          <p>1. 请详细解答以下问题：</p>
          <p class="question-content">{{ essayQuestion }}</p>
          <div class="answer-area">
            <p>解：</p>
            <div class="blank-lines">
              <div v-for="n in 10"
                   :key="'line-'+n"
                   class="blank-line"></div>
            </div>
          </div>
        </div>
      </section> -->

      <!-- 页脚 -->
      <!-- <footer class="paper-footer">
        <p>—— 完 ——</p>
        <p class="page-number">第 <span class="page"></span> 页</p>
      </footer> -->
    </div>

    <!-- 操作按钮 -->
    <div class="action-buttons">
      <button @click="generatePDF"
              class="download-btn">下载试卷</button>
      <button @click="printPaper"
              class="print-btn">打印试卷</button>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
  name: 'PaperGenerator',
  props: {
    paperList: {
      type: Array,
      default: () => {
        return []
      },
    },
    paperName: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  computed: {
    getWidth() {
      return function (Ba) {
        let content = []
        Ba.map((item) => {
          const tempDiv = document.createElement('div')
          tempDiv.innerHTML = item.description
          content.push(tempDiv.textContent || tempDiv.innerText)
        })

        if (content.some((v) => v.length > 19)) {
          return '600px'
        } else if (content.some((v) => v.length > 6 && v.length < 19)) {
          return '300px'
        } else {
          return '115px'
        }
      }
    },
    getEnglish() {
      return function (Ba) {
        if (Ba.length > 30) {
          return '600px'
        } else if (Ba.length > 1 && Ba.length < 10) {
          return '155px'
        } else {
          return '155px'
        }
      }
    },
    getEnglishuUnder() {
      return function (Ba) {
        if (Ba.length > 9) {
          return '100%'
        }
        // if (Ba.length > 9) {
        //   return '155px'
        // } else if (Ba.length > 9 && Ba.length < 19) {
        //   return '155px'
        // } else {
        //   return '155px'
        // }
      }
    },
  },
  watch: {
    paperList(val) {
      if (val) {
        console.log('vals22', val)
        val.map((v) => {
          if (v.answer_type_text == '') {
            v.answer_type_text = '单选题'
          }
          if (v.answer_type_text == '阅读理解') {
            v.answer_type_text = '材料题'
          }
          if (v.answer_type_text == '完型填空') {
            v.answer_type_text = '材料题'
          }
          if (v.answer_type_text == '完形填空') {
            v.answer_type_text = '材料题'
          }
          if (v.answer_type_text == '长难句') {
            v.answer_type_text = '问答题'
          }
        })
        val.map((item, index) => {
          this.dataList.push(item.answer_type_text)
          if (item.answer_type_text == '单选题') {
            this.topics[1].children.push(item)
          } else if (item.answer_type_text == '多选题') {
            this.topics[2].children.push(item)
          } else if (item.answer_type_text == '材料题') {
            this.topics[5].children.push(item)
          } else if (item.answer_type_text == '问答题') {
            this.topics[4].children.push(item)
          } else if (item.answer_type_text == '判断题') {
            this.topics[0].children.push(item)
          } else if (item.answer_type_text == '填空题') {
            this.topics[3].children.push(item)
          } else if (item.answer_type_text == '名词解释') {
            this.topics[6].children.push(item)
          } else if (item.answer_type_text == '论述题') {
            this.topics[7].children.push(item)
          } else if (item.answer_type_text == '简答题') {
            this.topics[8].children.push(item)
          }
        })
        this.dataList = [...new Set(this.dataList)]
        console.log('datalist', this.dataList)
        this.dataList.map((items, index) => {
          this.tabList[index] = {
            children: [],
          }
          this.$set(this.tabList[index], 'answer_type_text', items)
        })
        console.log('this.topics', this.tabList)
        this.topics.map((itenh) => {
          this.tabList.map((itemp) => {
            if (itenh.answer_type_text == itemp.answer_type_text) {
              itemp.children = itenh.children
            }
          })
        })
        console.log('this.tablist', this.tabList)

        this.tabList = this.tabList.filter((item) => item.children.length > 0)
        this.tabList.map((item, index) => {
          this.number.map((items, indexs) => {
            if (index == indexs) {
              this.$set(item, 'number', items)
            }
          })
        })

        // // 往对象里面添加数字
        this.tabList.map((item) => {
          item.children.map((k) => {
            if (k.answer_type_text != '材料题') {
              k.num = this.num++
              // this.$set(k, 'num', this.num++)
            }
            if (k.children) {
              k.children.map((i) => {
                this.$set(i, 'num', this.num++)
                if (i.answer_type_text == '多选题') {
                  i.options.map((intenH, index) => {
                    this.multipleChoice.map((items, indexs) => {
                      if (index == indexs) {
                        intenH.number = items
                        // this.$set(intenH, 'number', items)
                      }
                    })
                  })
                }
              })
            }
            if (k.answer_type_text == '多选题') {
              this.multipleChoice.map((items, indexs) => {
                k.options.map((k, p) => {
                  if (p == indexs) {
                    // this.$set(k, 'number', items)
                    k.number = items
                  }
                })
              })
            }
          })
        })
        this.scortArray()
        this.$nextTick(() => {
          // this.reset()
          this.generatePDF()
        })
      }
    },
    paperName(val) {
      this.paperTitle = val
    },
  },
  data() {
    return {
      list: [],
      paperTitle: '',
      score: 0,
      count: 0,
      number: ['一', '二', '三', '四', '五', '六', '七', '八', '九'],
      multipleChoice: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
      num: 1,
      copyTicps: [],
      dataList: [],
      tabList: [],
      topics: [
        {
          answer_type_text: '判断题',
          children: [],
        },
        {
          answer_type_text: '单选题',
          children: [],
        },
        {
          answer_type_text: '多选题',
          children: [],
        },
        {
          answer_type_text: '填空题',
          children: [],
        },
        {
          answer_type_text: '问答题',
          children: [],
        },
        {
          answer_type_text: '材料题',
          children: [],
        },
        {
          answer_type_text: '名词解释',
          children: [],
        },
        {
          answer_type_text: '论述题',
          children: [],
        },
        {
          answer_type_text: '简答题',
          children: [],
        },
        {
          answer_type_text: '阅读理解',
          children: [],
        },
        {
          answer_type_text: '完形填空',
          children: [],
        },
      ],
    }
  },
  methods: {
    // 判断字符串里面全是英文的
    isAllEnglish(str) {
      if (str != null) {
        const pattern = /[a-zA-Z]{3}/
        return pattern.test(str)
      } else {
        return true
      }
    },
    reset() {
      this.topics = [
        {
          answer_type_text: '判断题',
          children: [],
        },
        {
          answer_type_text: '单选题',
          children: [],
        },
        {
          answer_type_text: '多选题',
          children: [],
        },
        {
          answer_type_text: '填空题',
          children: [],
        },
        {
          answer_type_text: '问答题',
          children: [],
        },
        {
          answer_type_text: '材料题',
          children: [],
        },
        {
          answer_type_text: '名词解释',
          children: [],
        },
        {
          answer_type_text: '论述题',
          children: [],
        },
        {
          answer_type_text: '简答题',
          children: [],
        },
      ]
      this.num = 1
    },
    //将分数放进数组里面
    scortArray() {
      //将分数放到一个新的
      this.tabList.map((items) => {
        items.children.map((k) => {
          // 查找最后一个 span 标签的结束标签 </span>
          if (k.answer_type_text != '材料题') {
            k.description = k.description.replace(
              /<span[^>]*>(.*?)<\/span>/g,
              '$1'
            )
            const lastSpanIndex = k.description.lastIndexOf('</p>')
            if (k.description != '') {
              if (k.score != null && k.score != 0) {
                if (lastSpanIndex !== -1) {
                  k.dt =
                    k.description.slice(0, lastSpanIndex) +
                    '(' +
                    k.score +
                    '分)' +
                    k.description.slice(lastSpanIndex)
                }
              } else {
                k.dt = k.description
              }

              k.dts = k.dt.replace(
                /(<p[^>]*>)(.*?)(<\/p>)/,
                (match, p1, p2, p3) => `${p1}${k.num}、${p2}${p3}`
              )
            } else {
              k.dts = ''
            }
          } else {
            k.children.map((p) => {
              p.description = p.description.replace(
                /<span[^>]*>(.*?)<\/span>/g,
                '$1'
              )
              // 将分数存入字段前面
              const lastSpanIndex = p.description.lastIndexOf('</p>')
              if (p.score != null && p.score != 0) {
                if (lastSpanIndex !== -1) {
                  p.dt =
                    p.description.slice(0, lastSpanIndex) +
                    '        (' +
                    p.score +
                    '分)' +
                    p.description.slice(lastSpanIndex)
                }
              } else {
                p.dt = p.description
              }

              p.dts = p.description.replace(
                /(<p[^>]*>)(.*?)(<\/p>)/,
                (match, p1, p2, p3) => `${p1}${p.num}、${p2}${p3}`
              )
            })
          }
          // 判断是否是英语试卷，英语试卷材料题首行缩进
          if (!this.isAllEnglish(k.rich_text)) {
            k.rich_text = k.rich_text.replace(
              /<\p>/g,
              '</p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
            )

            k.rich_text = k.rich_text.replace(
              /<p([^>]*)>/g,
              '<p$1 style="margin-top: 10px;">'
            )
          }
        })
      })
      console.log('this.tablist', this.tabList)
    },
    generatePDF() {
      // 显示加载状态
      this.$message.info('正在生成PDF，请稍候...')
      // 获取试卷内容元素
      const element = document.getElementById('paper-content')

      const opt = {
        margin: [25, 5, 15, 5], // 上边距增加到25mm以容纳页眉 [上,右,下,左]
        filename: `${this.paperTitle}.pdf`,
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        html2canvas: {
          scale: 3,
          logging: false,
          useCORS: true,
          allowTaint: true,
          scrollX: 0,
          scrollY: 0,
          windowWidth: element.scrollWidth,
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
        },
        pagebreak: {
          mode: 'avoid-all',
          before: '.section-answer',
        },
      }

      // 生成PDF
      html2pdf()
        .set(opt)
        .from(element)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          // 添加页码
          const totalPages = pdf.internal.getNumberOfPages()
          const pageWidth = pdf.internal.pageSize.getWidth()
          const logoUrl =
            'https://upload.kaoyanbox.net/89c3bce4c750c10e2faadddc30961c3b.png'
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i)
            // 保存当前图形状态
            pdf.saveGraphicsState()
            pdf.addImage(logoUrl, 'PNG', 15, 13.5, 20, 3) // 调整位置和大小
            // 设置页眉样式
            pdf.setFont('helvetica', 'bold')
            pdf.setFontSize(11)
            pdf.setTextColor(40)

            // 添加学校名称（左侧）
            // pdf.text('某某高级中学', 20, 15)

            // 添加试卷标题（居中）
            // pdf.text(this.paperTitle, pageWidth / 2, 15, { align: 'center' })

            // 添加日期（右侧）
            // const currentDate = new Date().toLocaleDateString()
            // pdf.text(currentDate, pageWidth - 20, 15, { align: 'right' })

            // 添加页眉装饰线
            pdf.setDrawColor(0)
            pdf.setLineWidth(0.3)
            pdf.line(15, 18, pageWidth - 15, 18)
            // 恢复图形状态
            pdf.restoreGraphicsState()
            // 保留原有的页码代码
            // pdf.setFontSize(10)
            // pdf.text(
            //   `第 ${i} 页 共 ${totalPages} 页`,
            //   pdf.internal.pageSize.getWidth() - 40,
            //   pdf.internal.pageSize.getHeight() - 10
            // )
          }
        })
        .save()
        .then(() => {
          // this.$message.success('PDF下载成功！')
          this.reset()
          this.tabList = []
          this.dataList = []
          // this.paperList = []
        })
        .catch((err) => {
          console.error('生成PDF失败:', err)
          this.$message.error('生成PDF失败，请重试')
        })
    },
    printPaper() {
      window.print()
    },
  },
}
</script>

<style scoped lang="less">
.paper-container {
  opacity: 0;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
.topic {
  width: 93%;
  margin: 0 auto;
  padding-bottom: 90px;
  min-height: 500px;
  .topicItem {
    width: 100%;
    min-height: 90px;
    margin-top: 23px;
    .topicTitle {
      font-family: 'MyCustomFont', serif;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.9);
    }
    .descript {
      display: flex;
      min-height: 20px;
      margin-top: 16px;
      font-family: 'MySongFont', serif;
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.9);
      .descritAnswer {
        font-size: 14px;
        text-align: justify;
        line-height: 20px;
        letter-spacing: 0.3px;
        font-weight: 400 !important;
      }
    }
    .dstContent {
      margin-top: 8px;
      .descriptChild {
        padding-bottom: 8px;
        display: flex;
        min-height: 20px;
        line-height: 20px;
        font-family: 'MyRegularFont', serif;
        font-weight: 500;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.9);
      }
      .english {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30px;
      }
    }

    .option {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      font-family: 'MySongFont', serif;
      // font-weight: bold;
      margin-top: 12px;
      margin-bottom: 14px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.9);
      div {
        display: flex;
        padding-bottom: 10px;
        // margin-right: 60px;
        width: 115px;
      }

      .xuhao {
        font-family: 'MyCustomFont', serif;
      }
    }
    .multeoption {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      font-family: 'MySongFont', serif;
      font-weight: bold;
      margin-top: 12px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.9);
      .multeDiv {
        display: flex;
        padding-bottom: 12px;
        .xuhao {
          font-family: 'MyCustomFont', serif;
        }
      }
    }
  }
}

.paper-content {
  background-color: #fff;
  padding: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.paper-header {
  text-align: center;
  margin: 0;
  font-family: 'MyCustomFont', serif;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
  margin-bottom: 30px;
}

.paper-info {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
  font-size: 16px;
}

.section-choice,
.section-fill,
.section-answer {
  margin-bottom: 30px;
}

.section-choice h2,
.section-fill h2,
.section-answer h2 {
  font-size: 18px;
  /* border-left: 4px solid #1890ff; */
  padding-left: 10px;
  margin: 20px 0;
}

.question-item {
  margin-bottom: 20px;
}

.options {
  list-style-type: none;
  padding-left: 20px;
}

.options li {
  margin: 5px 0;
}

.answer-area {
  margin-top: 15px;
}

.blank-lines {
  margin-top: 10px;
}

.blank-line {
  height: 1px;
  border-bottom: 1px solid #333;
  margin: 15px 0;
}

.paper-footer {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px dashed #999;
}

.page-number {
  text-align: right;
  font-size: 12px;
}

.action-buttons {
  margin-top: 30px;
  text-align: center;
}

.download-btn,
.print-btn {
  padding: 8px 20px;
  margin: 0 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.download-btn {
  background-color: #1890ff;
  color: white;
}

.print-btn {
  background-color: #52c41a;
  color: white;
}

@media print {
  .action-buttons {
    display: none;
  }

  .paper-content {
    box-shadow: none;
    padding: 0;
  }
}
</style>